import React, { useEffect, useState } from 'react';
import classes from './ShortView.module.css';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import TVCard from '../TVPage/TVCard/TVCard';
import logo from '../../Assets/Logo/logo.svg';
import PageNotFound from '../PageNotFound/PageNotFound';
import { singlePostDataGet } from '../../Store/singlePostSlice';
import { useDispatch, useSelector } from 'react-redux';
import TVShortsCard from '../TVPage/TVCard/TVShortsCard';
import ShortsView from './ShortView';
import axios from 'axios';
import { apiErrorCodes } from '../../apiErrorCodes';
import { newPagePostsAdd } from '../../Store/TVPagePostsSlice';
import { CircularProgress } from '@mui/material';
import API from '../../Axios/axios';
import TVPageLeft from '../TVPage/TVPageLeft/TVPageLeft';
import TVPageRight from '../TVPage/TVPageRight/TVPageRight';

export default function SingleShort() {
  const query = useSearchParams();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { postId } = params;
  const [status, setStatus] = useState('loading');
  // shorts data
  // if user is viewing only one creators shorts
  const [creatorId, setCreatorId] = useState()

  const { postsData } = useSelector((state) => state.TVPagePostsSlice);
  const [creatorPosts, setCreatorPosts] = useState([])
  const [page, setPage] = useState(query['page']);
  const [loading, setLoading] = useState(false);
  const [lastPage, setLastPage] = useState(false);

  const getPostData = async () => {
    if (postsData?.urls?.next !== null && page > 1) {
      try {
        setLoading(true);
        const response = await axios.get(`${postsData.urls.next}`, {
          headers: { Authorization: `token ${localStorage.getItem('token')}` },
        });
        dispatch(newPagePostsAdd(response.data.message));
      } catch (error) {
        if (error.response.data.code === apiErrorCodes.NOT_FOUND) {
          setLastPage(true);
        } else if (
          error.response.data.code === apiErrorCodes.INVALID_TOKEN ||
          error.response.data.code === apiErrorCodes.AUTHENTICATION_FAILED ||
          error.response.data.code === apiErrorCodes.NOT_AUTHENTICATED ||
          error.response.data.code === apiErrorCodes.ACCOUNT_NOT_EXIST
        ) {
          localStorage.removeItem('token');
        }
      }
      finally {
        setLoading(false);
      }
    }
  };

  const getCreatorData = async function (creatorId) {
    try {
      const response = await API.get(`/accounts/${creatorId}/profile/`, {
        headers: {
          Authorization: `token ${localStorage.getItem('token')}`,
        },
      });
      if (response.data.code === apiErrorCodes.SUCCESS) {
        setCreatorPosts(response.data.message.my_posts);
        setStatus('done');
      }
    } catch (error) {
      if (error.response.data.code === apiErrorCodes.AUTHENTICATION_FAILED || error.response.data.code === apiErrorCodes.NOT_AUTHENTICATED || error.response.data.code === apiErrorCodes.INVALID_TOKEN || error.response.data.code === apiErrorCodes.ACCOUNT_NOT_EXIST) {
        localStorage.removeItem('token');
        navigate('/entry/signin');
      }
    }
  };


  useEffect(() => {
    if (!creatorId) {
      getPostData();
      setStatus('done');

    }
  }, [page]);

  useEffect(() => {
    if (creatorId) {
      getCreatorData(creatorId)
    }
  }, [creatorId])
  // set the creator id if included url
  useEffect(() => {
    console.log(query[0].get('u'))
    const _creatorId = query[0].get('u');
    if (_creatorId) {
      setCreatorId(atob(_creatorId))
    }
  }, [])

  if (status === 'loading') {
    return '';
  }
  if (status === 'error') {
    return <PageNotFound />;
  }

  return (
    <>
      {/*<Helmet>*/}
      {/*  {postData.project_title !== null ? (*/}
      {/*    <title>{`${postData.creator.name} | ${postData.project_title} | Srijcon`}</title>*/}
      {/*  ) : (*/}
      {/*    <title>{`${postData.creator.name} | Srijcon`}</title>*/}
      {/*  )}*/}
      {/*  <link rel="canonical" href="/" />*/}
      {/*  <meta name="description" content={`${postData.text}`} />*/}
      {/*</Helmet>*/}
      {localStorage.getItem('token') ? (
        ''
      ) : (
        <div className={classes.navbar}>
          <div className={classes.logoContainer}>
            <img
              draggable="false"
              src={logo}
              alt="Srijcon Logo"
              className={classes.logo}
            />
            <p className={classes.logoText}>Srijcon </p>
          </div>
          <div>
            <button
              className={classes.signInButton}
              onClick={() => navigate('/entry/signin')}
            >
              Sign In
            </button>
          </div>
        </div>
      )}

      <div className={classes.tvPage}>
        <TVPageLeft />
        <main className={classes.main}>
          <ShortsView currentPostId={postId} onLastPostVisited={() => {
            if (!creatorId) {
              setPage((prev) => prev + 1);
            }
          }} posts={creatorId ? creatorPosts : postsData.results} />
        </main>
        <TVPageRight />
      </div>

      {loading && postsData?.urls?.next !== null && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress color={'primary'} />
        </div>
      )}

    </>
  );
}
